import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSharedCostByDimensionIdThunk } from "@/store/dimensions/thunks/shared-costs/getSharedCostByDimensionIdThunk";

export const getAndCheckSharedCostWithEvenSplitMethodExistenceThunk =
  createAsyncThunk(
    "dimensions/getAndCheckSharedCostWithEvenSplitMethodExistence",
    async (dimensionId: string, { dispatch }) => {
      if (!dimensionId) {
        return;
      }

      const sharedCosts = await dispatch(
        getSharedCostByDimensionIdThunk({ dimensionId, forceRefetch: true }),
      ).unwrap();

      return !!sharedCosts?.some(
        (sharedCost) => sharedCost.distribution_type === "even",
      );
    },
  );
